import React, { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import { v4 as uuidv4 } from 'uuid';
import { onlyNumberWithDecimal } from '../../components/functions'
import { Link } from 'react-router-dom'
import api from '../api';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { useEnergiaIdentificacaoContext } from '../../context/energiaIdentificacaoContext'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'


//import $ from 'jquery'


const Identificacao = (props) => {

    const energia_id = props.energia_id

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()    

    const {energiaResponsavel_id, setEnergiaResponsavel_id} = useEnergiaIdentificacaoContext()
    const [resultadoResponsaveis, setResultadoResponsaveis] = useState()




    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao, setQuestao] = useState()



    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Identificação':

                                setQuestao('red')
    
                            break

                            
                        }

                    }

                    

                }

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    function consultaResponsavel() {


        if (energia_id) {

            api.get(`energiaResponsavelListaTodos/${energia_id}`).then((result) => {


                setResultadoResponsaveis(result.data.map((rs) =>
                
                    <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalEnergiaIdentificacao').modal('show');setEnergiaResponsavel_id(rs.energiaResponsavel_id)}}>
                        <td>
                            {rs.nome}
                        </td>
                        <td>
                            {rs.email}
                        </td>
                        <td>
                            {rs.telefone}
                        </td>
                    </tr>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }

    
    useEffect(() => {

        //console.log('aqui...')

        consultaResponsavel()

    }, [energia_id, atualizacaoGestao])

    


    return (

        <div>

            
            <div className="col-md-12">
                <div align="left">

                    <Link to='#' style={{ color: questao, display: 'none' }} onClick={() => {setEnunciado('Identificação');setSecaoEnunciado('Identificação');window.$('#modalValidacao').modal('show')}} >
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    <button type="button" className="btn btn-success" onClick={() => {window.$('#modalEnergiaIdentificacao').modal('show');setEnergiaResponsavel_id()}}  >+ Adicionar responsável</button>
                    <br/><br/>

                </div>
            </div>

            <div className="col-md-12">


            <Table striped bordered hover>

                <thead>
                    
                    <tr>
                        <th style={{backgroundColor: '#e6f7ec'}}>

                            Nome

                        </th>
                        <th style={{backgroundColor: '#e6f7ec'}}>

                            E-mail

                        </th>
                        <th style={{backgroundColor: '#e6f7ec'}}>

                            DDD + Telefone

                        </th>
                    

                    </tr>
                </thead>
                <tbody>
                    {resultadoResponsaveis}
                </tbody>

            </Table>


            </div>





        </div>
                

        

    )

}

export default Identificacao